module.exports = __webpack_public_path__ + "static/media/the-hand-of-midas.e5f84d8d.gif";